import { graphql } from "../gql";

export const drgCreateAnnotationMutationDoc = graphql(`
  mutation drgCreateAnnotation($input: DrgCreateAnnotationInput!) {
    drgCreateAnnotation(input: $input) {
      id
      orgId
      claimId
      page
      quote
      note
      fileId
      fileName
      citationKey
      sourceText
      evidenceItemId
      coordinates {
        left
        top
        width
        height
      }
      author {
        id
        email
        displayName
        orgId
      }
      linkedFinding {
        id
        code
        codeDescription
        verdict
      }
      createdAt
      updatedAt
      deletedAt
    }
  }
`);
